module.exports = __webpack_public_path__ + "static/media/gold-collected.517ec0b1.png";